<template>
    <button 
      @click="toggleChat" 
      class="cursor-pointer focus:outline-none hover:text-primary-dark active:text-primary-dark"
    >
      <support-navbar-icon />
    </button>
  </template>
  
  <script>
  import Auth from '@groovepages/gd-lib/auth';
  import axios from 'axios';
  import SupportNavbarIcon from '../assets/support-navbar-icon.svg';

  export default {
    name: 'SupportNavbar',
    components: {
      SupportNavbarIcon
    },
    data() {
      return {
        isOpen: false
      }
    },
    mounted() {
      // Add custom close button when chat widget appears
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            this.addCloseButton();
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },
    methods: {
      async toggleChat() {
        if (!window.$chatwoot) {
          const result = await this.initializeChat();

          if (result === "open-portal") {
            window.open(this.$t('official_link_support'), "_blank");
          }

          // Create an interval to check for the chat button
          const checkInterval = setInterval(() => {
            const chatButton = document.querySelector('.woot-widget-bubble');
            if (chatButton) {
              clearInterval(checkInterval);
              chatButton.click();
              this.addCloseButton();
              const chatWidget = document.querySelector('.woot-widget-holder');
              if (chatWidget) {
                chatWidget.style.display = 'block';
                this.isOpen = true;
              }
            }
          }, 100);

          setTimeout(() => clearInterval(checkInterval), 10000);
        } else {
          const chatWidget = document.querySelector('.woot-widget-holder');
          if (chatWidget) {
            if (this.isOpen) {
              chatWidget.style.display = 'none';
            } else {
              chatWidget.style.display = 'block';
            }
            this.isOpen = !this.isOpen;
          }
        }
      },
      addCloseButton() {
        const chatWidget = document.querySelector('.woot-widget-holder');
        if (chatWidget && !chatWidget.querySelector('.custom-close-button')) {
          const closeButton = document.createElement('div');
          closeButton.className = 'custom-close-button';
          closeButton.innerHTML = '×';
          closeButton.addEventListener('click', () => {
            chatWidget.style.display = 'none';
            this.isOpen = false;
          });
          chatWidget.appendChild(closeButton);
        }
      },
      async initializeChat() {
        const script = document.createElement('script');

        const { token } = Auth.authenticatedUser();
        const response = await axios.get(
          `${window.config.apiUrl}/../groovedigital/support-info`,
          {
            headers: {
              Authorization: 'Bearer ' + token, //the token is a variable which holds the token
            },
          }
        );

        const supportWidgetToken = response.data.support_widget_token;

        if (!supportWidgetToken || supportWidgetToken === '') {
          return "open-portal";
        }

        script.textContent = `
          (function(d,t) {
            const BASE_URL="https://app.chatwoot.com";
            const g=d.createElement(t),s=d.getElementsByTagName(t)[0];
            g.src=BASE_URL+"/packs/js/sdk.js";
            g.defer = true;
            g.async = true;
            s.parentNode.insertBefore(g,s);
            g.onload=function(){
              window.chatwootSDK.run({
                websiteToken: "${supportWidgetToken}",
                baseUrl: BASE_URL
              });
            }
          })(document,"script");
        `;
        document.head.appendChild(script);
      }
    }
  }
  </script> 
<style lang="scss">
  .woot-widget-bubble {
    display: none !important;
  }
  
  div.woot-widget-holder {
    bottom: 20px !important;
    right: 20px !important;
    overflow: visible !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

    
    .custom-close-button {
      position: absolute;
      top: -8px;
      left: -8px;
      width: 20px;
      height: 20px;
      background-color: rgb(227, 227, 227);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 16px;
      z-index: 999999;
      transition: background 0.2s ease-in-out;

      &:hover {
        color: var(--brand-danger);
      }
    }
  }
</style>
